import { action, autorun, computed, observable, reaction } from 'mobx'
import {
  getAllCansByGroupFetchHandler,
  getCleanerFetchHandler,
  getNewCansByGroupFetchHandler,
  // setCleanerAreaFetchHandler,
} from '../utils/fetchData'
import GroupInfoStore from '../store/GroupInfoStore'
import UserInfoStore from '../store/UserInfoStore'
import GlobalControlStore from './GlobalControlStore'

/*
  initMarker marker是否需要初始化
*/

class DistributeCansViewStore {
  @observable initMarker = false
  @observable isShowInput = false
  @observable hideInfoFlag = true
  @observable cleanerId = null
  @observable cleanerInfo = null
  @observable cansInfoMap = new Map()
  @observable enableDistribute = false
  @observable initialCanMarkersHandle = null
  @observable cleanerWorkArea = ''
  @observable cleanerWorkAreaNeedUpdate = false
  @observable cleanerWorkFinallValue = null
  @observable distrubuteSearchShow = false
  @observable distrubuteIsShow = false
  @observable distributeAllCheck = false
  @observable distributeCheckNum = 0
  @observable distributeCansMap = new Map()
  @observable distributeChoseCan = null
  @observable distributeInputValue = ''
  @observable distributeSearchArr = []
  @observable distributeCenterLng = ''
  @observable distributeCenterLat = ''
  @observable distributeMapNeedCenter = false
  @observable unallocatAllCheck = false
  @observable unallocatCheckNum = 0
  @observable unallocatCansMap = new Map()
  @observable unallocatIsShow = false
  @observable unallocatChoseCan = null
  @observable unallocatSearchArr = []
  @observable unallocatInputValue = ''
  @observable unallocatSearchShow = false
  @observable isUnallocatSearch = true

  @observable _choseId = null

  get choseId() {
    return this._choseId
  }

  @observable _previousId = null

  get previousId() {
    return this._previousId
  }

  
  @computed
  get cansCount() {
    let count = 0
    for (let can of this.distributeCansMap.values()) {
      count++
    }
    return count
  }

  @action setChoseID(value) {
    this._previousId = this._choseId
    this._choseId = value
  }

  setCanCheckedStatus(canId) {
    let can = this.cansInfoMap.get(canId)
    can.checked = !can.checked
    can.needUpdate = !can.needUpdate
  }
  @action.bound
  async getDistributeData() {
    if (this.cleanerId) {
      this.cansInfoMap.clear()
      this.distributeCansMap.clear()
      this.unallocatCansMap.clear()
      let [res, unRes] = await Promise.all([
        getAllCansByGroupFetchHandler(),
        getNewCansByGroupFetchHandler(),
      ])
      if (res.ok) {
        let resBody = await res.json()
        this.getDistributeCansSuccess(resBody)
      }
      if (unRes.ok) {
        let resBody = await unRes.json()
        this.getUnallocatCansSuccess(resBody)
      }
    }
  }
  @action getDistributeCansSuccess(data) {
    var arr1 = []
    for (let i = 0; i < data.length; i++) {
      if (data[i].supervisorId === store.cleanerId) {
        arr1.push(data[i])
      }
    }
    for (let can of arr1) {
      can.checked = false
      can.needUpdate = false
      this.cansInfoMap.set(can.id, can)
      this.distributeCansMap.set(can.id, can)
    }
    GlobalControlStore.showLoading = false
  }
  @action getUnallocatCansSuccess(data) {
    for (let can of data) {
      can.checked = false
      can.needUpdate = false
      this.cansInfoMap.set(can.id, can)
      this.unallocatCansMap.set(can.id, can)
    }
    this.initialCanMarkersHandle = true
    this.initMarker = true
  }
}
const store = new DistributeCansViewStore()

const getCleanerInfoAutorun = autorun(() => {
  store.cleanerInfo = GroupInfoStore.cleanerInfoMap.get(store.cleanerId)
})

// const setCleanerWorkArea = reaction(
//   () => store.cleanerWorkFinallValue,
//   (value, reaction) => {
//     setCleanerAreaFetchHandler(
//       store.cleanerId,
//       store.cleanerWorkFinallValue,
//       () => {},
//       () => {}
//     )
//   }
// )
const getCleanerArea = reaction(
  () => store.cleanerWorkAreaNeedUpdate,
  (update, reaction) => {
    if (update) {
      getCleanerFetchHandler(
        store.cleanerId,
        (data) => {
          if (data) {
            store.cleanerWorkArea = data
          }
        },
        () => {}
      )
    }
  }
)
export default store



// WEBPACK FOOTER //
// ./src/store/DistributeCansViewStore.js